import store from '@/store'
import _ from 'lodash'

export class CartService {
  addProductToCart () {
    const orderData = store.getters['cpOrder/allData']
    const productData = _.pick(orderData, ['cp_product_category', 'cp_product_sub_category', 'cp_product_reference', 'cp_product_options', 'quantity', 'cpProductInfo', 'type'])
    store.dispatch('cart/addProduct', productData)
    store.dispatch('cart/updateAddress', orderData.shipping_address)
  }

  editProduct (productIndex) {
    const orderData = store.getters['cpOrder/allData']
    const productData = _.pick(orderData, ['cp_product_category', 'cp_product_sub_category', 'cp_product_reference', 'cp_product_options', 'quantity', 'cpProductInfo', 'type', 'cp_files'])
    store.dispatch('cart/editProduct', { productIndex, productData })
    store.dispatch('cart/updateAddress', orderData.shipping_address)
  }
}
